import { CopyToClipboard } from "components/StentorUIComponents";
import React, { FC } from "react";

export interface WidgetSnippetCodeProps {
    readonly snippetKey: string;
    /**
     * Defaults to "widget", determines which snippet to create.
     */
    readonly product?: "widget" | "search" | "form";
    /**
     * Either hides the title or changes it.
     */
    readonly title?: string | boolean;
    /**
     * Hides the key field
     */
    readonly hideKey?: boolean;
    /**
     * Shows installation instructions
     */
    readonly showInstructions?: boolean;
}

function generateWidgetScript(key: string) {
    return `<script id="xapp-js" src="${window.xaStudioConfig?.widgetUrl}/xapp-chat-widget.js?key=${key ?? ""}"></script>`;
}

function generateSearchScript(key: string) {
    return `<script id="xapp-search-js" src="${window.xaStudioConfig?.searchUrl}/xapp-search-bar.js?key=${key ?? ""}"></script>`;
}

function generateFormScript(key: string) {
    return `<script src="https://unpkg.com/react@18.2.0/umd/react.production.min.js"></script>
<script src="https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js"></script>
<script id="xapp-form-js" src="${window.xaStudioConfig?.searchUrl}/xapp-form-widget.js?key=${key ?? ""}"></script>`;
}

const WORDPRESS_PLUGIN_INSTRUCTIONS = "https://documentation.xapp.ai/docs/channels/channel-chat-widget#wordpress-plugin";
const SNIPPET_INSTRUCTIONS = "https://documentation.xapp.ai/docs/channels/channel-chat-widget#script-tag";
const REACT_INSTRUCTIONS = "https://documentation.xapp.ai/docs/channels/channel-chat-widget#react-library";

export const WidgetSnippetCode: FC<WidgetSnippetCodeProps> = props => {

    const { product, snippetKey, hideKey, showInstructions } = props;

    let sample: string;
    const displayTitle: boolean = typeof props.title === "boolean" ? props.title : true;
    const title: string = typeof props.title === "string" ? props.title : "Chat Snippet";

    let keyHeader = "Widget Key";

    switch (product) {
        case "widget":
            keyHeader = "Chat Key";
            sample = generateWidgetScript(snippetKey);
            break;
        case "search":
            keyHeader = "Search Key";
            sample = generateSearchScript(snippetKey);
            break;
        case "form":
            keyHeader = "Form Key";
            sample = generateFormScript(snippetKey)
            break;

        default:
    }


    function getSnippetContent(): JSX.Element {

        return (<>{showInstructions ? (<p> Paste the following code snippet right before the <code>{"</body>"}</code> tag.  Read more about this <a href={SNIPPET_INSTRUCTIONS}>here.</a> </p >) : (<></>)} < CopyToClipboard textToCopy={sample} /></>)
    }

    function getKeyContent(): JSX.Element {
        if (hideKey) {
            return (<></>);
        } else {
            return (
                <>
                    <h3>{keyHeader}</h3>
                    {showInstructions ? (<p>Use your chat key to the <a href={WORDPRESS_PLUGIN_INSTRUCTIONS}>Wordpress plugin</a> or our <a href={REACT_INSTRUCTIONS}>React</a> integrations</p>) : (<></>)}
                    <CopyToClipboard textToCopy={snippetKey} />
                </>
            )
        }
    }

    return (
        <>
            {displayTitle ? <h3>{title}</h3> : <></>}
            {getSnippetContent()}
            {getKeyContent()}
        </>
    );
};